namespace $ { export class $mol_image2 extends $mol_view {

	/**
	 *  ```
	 *  links /
	 *  ```
	 **/
	links() {
		return [] as readonly any[]
	}

	/**
	 *  ```
	 *  aspect 1
	 *  ```
	 **/
	aspect() {
		return 1
	}

	/**
	 *  ```
	 *  sub / <= Content
	 *  ```
	 **/
	sub() {
		return [this.Content()] as readonly any[]
	}

	/**
	 *  ```
	 *  Content $mol_view style *
	 *  	paddingTop <= height
	 *  	backgroundImage <= background
	 *  ```
	 **/
	@ $mol_mem
	Content() {
		return (( obj )=>{
			obj.style = () => ({
			"paddingTop" :  this.height() ,
			"backgroundImage" :  this.background() ,
		})
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  height \100%
	 *  ```
	 **/
	height() {
		return "100%"
	}

	/**
	 *  ```
	 *  background \
	 *  ```
	 **/
	background() {
		return ""
	}

} }
